module.exports = __webpack_public_path__ + "img/mhcn-header.3c01fee7.png";